import {Controller} from "stimulus"

export default class extends Controller {
    toggleChoices(e) {
        const choicesArea = document.querySelector(".choices-area")
        const fieldsetArea = document.querySelector(".fieldset-config-area")
        const isChosable = ['select', 'radio', 'multi_select'].includes(e.target.value)
        const isFieldset = e.target.value === 'fieldset'

        if (choicesArea) {
            if (isChosable) {
                choicesArea.classList.remove("hidden")
            } else {
                choicesArea.classList.add("hidden")
            }
        }

        if (fieldsetArea) {
            if (isFieldset) {
                fieldsetArea.classList.remove("hidden")
            } else {
                fieldsetArea.classList.add("hidden")
            }
        }
    }
}
